const t=()=>Math.random().toString(36).substr(2,9);export{t as generateKey};
//# sourceMappingURL=generateKey.js.map
